/**
 * "I am standing here" — pins a record to the device's own position.
 *
 * Used by every address-driven thing the map plots: farm sites, distributor
 * depots and accommodation. Each owns different columns, so this component
 * does the asking and the judging, then hands the caller a normalised result
 * to store however that form stores things.
 *
 * See utils/deviceLocationPin.js for the wording and the accuracy threshold.
 */
import React, { useState } from 'react';
import { getDeviceLocationDetailed } from '../utils/geolocation';
import { describeDeviceFix } from '../utils/deviceLocationPin';

export default function UseMyLocationButton({
  onResult,
  noun = 'record',
  className = 'btn-geocode',
  disabled = false
}) {
  const [locating, setLocating] = useState(false);

  const handleClick = async () => {
    setLocating(true);
    try {
      // getDeviceLocationDetailed never rejects — a farm with no signal is
      // normal, so a failed pin is a message, not an error state.
      const result = describeDeviceFix(await getDeviceLocationDetailed(), noun);
      onResult(result);
    } finally {
      // Always re-enabled: a timeout on the first try is the common case and
      // the next attempt often works.
      setLocating(false);
    }
  };

  return (
    <button
      type="button"
      className={`${className} btn-use-location`}
      onClick={handleClick}
      disabled={disabled || locating}
    >
      {locating ? 'Locating...' : '📍 Use my current location'}
    </button>
  );
}
